export default {
  service_partners_list: (state) => state.service_partners_list,
  servicepartners: (state) => state.servicepartners,
  provisioned_orders: (state) => state.provisioned_orders,
};
